(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("ProfilePictureCtrl", ["authService", "$scope", "$timeout", "$translate", "ngJcropConfig", "messageService", "myAccountResource", "Upload", "FILE_FORMATS", profilePictureCtrl]);
    function profilePictureCtrl(authService, $scope, $timeout, $translate, ngJcropConfig, messageService, myAccountResource, Upload, FILE_FORMATS) {
        var vm = this;
        vm.jcropData = {};
        vm.model = {};
        vm.saving = false;
        vm.loading = true;
        vm.hasPicture = false;
        vm.acceptedFileTypes = FILE_FORMATS.image;
        vm.acceptedFileTypesFormated = vm.acceptedFileTypes.replace(/,/g, ", "); //Adds a space after each comma for better displaying
        //Configure JCrop Properties
        ngJcropConfig.profile = {};
        angular.extend(ngJcropConfig.profile, ngJcropConfig.default);
        ngJcropConfig.profile.jcrop = {
            bgColor: "#fff",
            minSize: [24, 24],
            maxSize: [600, 0],
            maxHeight: 299.9,
            boxWidth: 270,
            boxHeight: 270,
            aspectRatio: 1,
            onChange: updateCrop,
            onSelect: updateCrop
        };
        ngJcropConfig.profile.previewImgStyle = {
            display: "none"
        };
        vm.jcropData.coords = [0, 0, 0, 0, 0, 0];
        myAccountResource.getProfilePicture(function (result) {
            if (!result.originalProfilePictureUrl) {
                vm.loading = false;
                vm.hasPicture = false;
            }
            else {
                loadCropArea(result);
            }
        }, function () {
            messageService.error("common.genericError");
        });
        vm.upload = function (file) {
            vm.file = file;
            if (file) {
                file.upload = Upload.upload({
                    url: "api/account/profilePicture/upload",
                    data: { file: file }
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        loadCropArea(response.data);
                        authService.updateUserData({ pictureUrl: response.data.profilePictureUrl });
                        messageService.success("common.dropzone.uploadedFileMessage");
                        vm.file.progress = 0;
                    });
                }, function (response) {
                    if (response.status > 0) {
                        messageService.error(response);
                    }
                    vm.file.progress = 0;
                }, function (evt) {
                    file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                });
            }
        };
        vm.save = function () {
            if (vm.coords.h === 0 && vm.coords.w === 0)
                messageService.error("common.error.invalidCropSize");
            else {
                vm.saving = true;
                vm.model.coordinates = vm.coords;
                myAccountResource.cropProfilePicture(vm.model, function (result) {
                    loadCropArea(result);
                    vm.saving = false;
                    authService.updateUserData({ pictureUrl: result.profilePictureUrl });
                    messageService.success("account.profile.picture.save.success");
                    $scope.$dismiss();
                }, function () {
                    messageService.error("common.genericError");
                    vm.saving = false;
                });
            }
        };
        vm.removePicture = function () {
            var message = $translate.instant("account.profile.picture.remove.confirm");
            if (confirm(message)) {
                myAccountResource.removeProfilePicture(function () {
                    vm.hasPicture = false;
                    authService.updateUserData({ pictureUrl: "" });
                    messageService.success("account.profile.picture.remove.success");
                }, function () {
                    messageService.error("common.genericError");
                });
            }
            ;
        };
        function updateCrop(coords) {
            vm.coords = coords;
            $scope.$apply();
        }
        function loadCropArea(result) {
            var logoUrl = result.originalProfilePictureUrl;
            // Loading image to get the actual Width and Height
            var image = new Image();
            image.onload = function () {
                $scope.$apply(function () {
                    ngJcropConfig.profile.jcrop.trueSize = [image.naturalWidth, image.naturalHeight];
                    vm.jcropData.src = logoUrl;
                    var cropData = JSON.parse(result.cropData);
                    if (!cropData) {
                        vm.jcropData.coords = [0, 0, image.naturalWidth, image.naturalHeight, image.naturalWidth, image.naturalHeight];
                    }
                    else {
                        vm.jcropData.coords = [cropData.coordinates.x, cropData.coordinates.y, cropData.coordinates.x2, cropData.coordinates.y2, cropData.coordinates.w, cropData.coordinates.h];
                    }
                    vm.loading = false;
                    vm.hasPicture = true;
                    $timeout.cancel(cantLoadImageTimeout);
                });
            };
            image.onerror = function () {
                vm.loading = false;
            };
            image.src = logoUrl;
            var cantLoadImageTimeout = $timeout(function () {
                vm.loading = false;
                vm.hasPicture = false;
            }, 10000);
        }
    }
}());
